
import type { ReactElement, ReactNode } from 'react'

interface StatCardProps {
  icon: string | ReactNode
  number: string | number
  label: string
  suffix?: string
}

interface Stat {
  icon: string
  number: string
  label: string
}

const StatCard = ({
  icon,
  number,
  label,
  suffix = '+',
}: StatCardProps) => {
  return (
    <div className="bg-white rounded-3xl py-2 sm:py-3 shadow-md hover:shadow-lg transition-shadow duration-300 flex items-center gap-3 w-full sm:w-[240px] md:w-[260px] border border-[#CDCDCD] px-3 space-x-2">
      <div className="flex-shrink-0">
        {typeof icon === 'string' ? (
          <img src={icon} alt="" className="h-15 w-15" />
        ) : (
          icon
        )}
      </div>

      <div className="flex flex-col">
        <div className="text-left text-2xl font-bold leading-tight sm:text-3xl">
          {number}
          {suffix}
        </div>

        <div className="mt-0.5 text-left text-xs text-black sm:text-sm">
          {label}
        </div>
      </div>
    </div>
  )
}

const StatsSection = (): ReactElement => {
  const stats: Stat[] = [
    {
      icon: '/startup.svg',
      number: '80',
      label: 'Startups Built',
    },
    {
      icon: '/year.svg',
      number: '09',
      label: 'Years in Business',
    },
    {
      icon: '/countries.svg',
      number: '04',
      label: 'Countries',
    },
  ]

  return (
    <section className="relative my-3">
      <div className="relative z-10 px-0">
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 md:flex-nowrap md:gap-8 lg:justify-between text-[#000000]">
          <div className="flex w-full flex-col gap-4 sm:flex-row sm:gap-6 lg:w-auto">
            {stats.map((stat, index) => (
              <StatCard
                key={index}
                icon={stat.icon}
                number={stat.number}
                label={stat.label}
              />
            ))}
          </div>

          <a
            href="https://clutch.co/profile/lemolite-technologies-llp"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0"
          >
            <div className="mt-6 flex cursor-pointer sm:hidden md:hidden lg:flex lg:mt-0">
              <img
                src="/Badgeblack.png"
                alt="Clutch review"
                width={110}
                height={40}
                className="object-contain"
              />
            </div>
          </a>
        </div>
      </div>
    </section>
  )
}

export default StatsSection

